import * as React from 'react';
import { buildUrl } from '../../coraWebComponents/utils/helper';

const Brand = props =>
  <>
    <img src={buildUrl('assets/sitelLogo.svg')} alt="SITEL" style={{ height: '35px', filter: 'brightness(3)' }} />
  </>
export default Brand;